import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import AppRecoveryBoundary from './components/AppRecoveryBoundary';
import { markAppStartupComplete } from './startupTelemetry';
import { applyTelegramStartParameterFromWindow } from './telegramStartParameter';
// @ts-ignore
import reportWebVitals from './reportWebVitals';

/**
 * AppStartupSignal
 *
 * Marks startup as complete only after React commits the application tree. It
 * receives no props, depends on the inline startup telemetry API, and clears
 * the preview-page timeout through a one-time mount effect.
 */
function AppStartupSignal() {
  useEffect(() => {
    markAppStartupComplete();
  }, []);

  return null;
}

// Resolve Telegram's documented navigation payload before BrowserRouter reads
// the initial location. Invalid or absent values deliberately keep the normal
// web entry point and its existing safe fallback behavior.
applyTelegramStartParameterFromWindow();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <AppRecoveryBoundary>
      <App />
      <AppStartupSignal />
    </AppRecoveryBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
